<template>
  <div>
    <Card title="Ratings">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search name" v-model="filter.q" @change="searchRating" ></el-input>
              </div>
              <Button @clicked="searchRating" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetRating" /></button>
            </div>
            <download-excel
              class="md:w-50"
              :data="data"
              :fields="excel_fields"
              :meta="excel_meta"
              worksheet="My Worksheet"
              name="ratings.xls"
            >
              <div v-bind:class="'bg-indigo-500 text-gray-100'" class="flex items-center px-4 py-3 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                <p class="m-auto text-xs font-medium">
                  Download Excel
                </p>
              </div>
            </download-excel>
          </div>
        </div>
        <data-tables-server ref="tableRating" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" width="120px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <a @click="detail(scope.row)" class="inline-block p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialogDetail
      :isShowingModal="isShowingModal"
      :isLoading="isLoading"
      title="Detail Rating"
      @toggleModal="toggleModal()"
    >
      <template slot="body" >
        <div class="py-6" style="min-width: 360px">
          <form-item label='Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.customer_name:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Email'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.customer_email:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Country'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.country:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Submission Date'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.submission_date:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Attempts'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.attempts:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Rating'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?selectedRow.score:'-' }}</p>
            </template>
          </form-item>
          <form-item label='Feedback'>
            <template v-slot>
              <p class="text-left font-bold">{{ selectedRow!=null?(!!selectedRow.feedback?selectedRow.feedback:'-'):'-' }}</p>
            </template>
          </form-item>
        </div>
      </template>
    </ModalDialogDetail>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialogDetail from '../../components/Common/ModalDialogDetail';
import { Button, FormItem } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

Vue.component('downloadExcel', JsonExcel);
export default {
  name: 'RatingList',
  data() {
    return {
      excel_fields: {
        Name: 'customer_name',
        'User Email': 'customer_email',
        Country: 'country',
        'Submission Date': 'submission_date',
        Attempts: 'attempts',
        Ratings: 'score',
        Feedback: 'feedback',
      },
      excel_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      isLoading: false,
      isShowingModal: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      titles: [{
        prop: {
          field: 'customer_name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'customer_email',
        },
        label: 'User Email',
      }, {
        prop: {
          field: 'submission_date',
        },
        label: 'Submission Date',
      }, {
        prop: {
          field: 'attempts',
        },
        label: 'Attempts',
      }, {
        prop: {
          field: 'score',
        },
        label: 'Ratings',
      }],
      filter: {
        page: 1,
        per_page: 20,
        q: '',
        sortby: 'created_at',
        sortorder: 'desc',
      },
      selectedRow: null,
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCountry();
    await this.requestListRatings(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('RatingSurveyModule', ['listRatings']),
    ...mapGetters('AppSettingModule', ['listCountry']),
  },
  watch: {
    listRatings: {
      immediate: true,
      async handler(val) {
        if (val.data) {
          await this.refineData();
        }
      },
    },
  },
  methods: {
    ...mapActions('RatingSurveyModule', ['requestListRatings', 'requestDetailRating']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async searchRating() {
      this.filter.page = 1;
      await this.requestListRatings(this.filter);
    },
    async resetRating() {
      this.$refs.tableRating.$refs.elTable.clearSort();
      this.filter.page = 1;
      this.filter.q = '';
      await this.requestListRatings(this.filter);
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      const pageSize = queryInfo.pageSize;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order;
      if (typeof (sortorder) === 'undefined') {
        sortorder = 'desc';
      } else {
        sortorder = queryInfo.sort.order === 'ascending' ? 'asc' : 'desc';
      }
      if (typeof (sortby) === 'undefined'  || sortby === 'submission_date') {
        sortby = 'created_at';
      }
      this.filter = Object.assign(this.filter, { page, sortby, sortorder, per_page: pageSize });
      await this.requestListRatings(this.filter);
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
    },
    refineData() {
      this.data = this.listRatings.data.data.map((val) => {
        const country = this.listCountry.filter(c => c.code === val.customer_country);
        return { ...val,
          submission_date: moment(val.created_at).format('YYYY-MM-DD HH:mm:ss'),
          country: country.length > 0 ? country[0].name : val.customer_country,
          feedback: val.feedback ? val.feedback : '-',
        };
      });
      this.total = this.listRatings.data.total;
    },
    detail(row) {
      this.selectedRow = row;
      this.toggleModal();
    },
  },
  components: {
    ModalDialogDetail,
    VueCustomTooltip,
    Button,
    Card,
    CardStats,
    FormItem
  },
};
</script>

<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/RatingSurvey/RatingList.vue